var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as React from 'react';
import { observer } from 'mobx-react';
import { ListItem, ListItemIcon, ListItemContent, ListItemIconWrapper, EmptyCheckbox, Checkedbox, } from './components';
let ListBoardItemV2 = class ListBoardItemV2 extends React.Component {
    constructor(props) {
        super(props);
        this.state = { dropped: false };
    }
    render() {
        const { props } = this;
        const { item, list, showCheckbox, selectedOrders, setSelectedOrders } = props;
        const handleItemClick = () => {
            if (showCheckbox && item._id) {
                const isExistedId = selectedOrders.find(orderId => orderId === item._id);
                if (!isExistedId) {
                    setSelectedOrders([...selectedOrders, item._id]);
                }
                else {
                    const filteredExistedItem = selectedOrders.filter(orderId => orderId !== item._id);
                    setSelectedOrders(filteredExistedItem);
                }
            }
        };
        const isChecked = selectedOrders.includes(item._id);
        return (React.createElement(ListItem, { onClick: handleItemClick, active: showCheckbox && isChecked },
            React.createElement(ListItemIconWrapper, null,
                React.createElement(ListItemIcon, null, props.renderIcon(item, list)),
                showCheckbox && !isChecked && React.createElement(EmptyCheckbox, null),
                showCheckbox && isChecked && React.createElement(Checkedbox, null)),
            React.createElement(ListItemContent, null, props.renderRow(item, list)),
            props.renderBottom && props.renderBottom(item, list)));
    }
};
ListBoardItemV2 = __decorate([
    observer
], ListBoardItemV2);
export { ListBoardItemV2 };
//# sourceMappingURL=item.js.map